import * as React from 'react'
import { createContainer } from 'unstated-next'

interface AddToBagErrors {
  missingRequiredSize: boolean
}

function useMultiAddToBag() {
  const [addToBagErrors, setAddToBagErrors] = React.useState<AddToBagErrors>({
    missingRequiredSize: false,
  })

  const [isAddToCartInFlight, setIsAddToCartInFlight] = React.useState<boolean>(false)

  return {
    addToBagErrors,
    isAddToCartInFlight,
    setIsAddToCartInFlight,
    setAddToBagErrors,
  }
}

export const MultiAddToBagService = createContainer(useMultiAddToBag)
